import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PAGE_SIZES } from '@/components/ui/data-pagination';
import { HOME_TABS, INBOX_SHOWS } from '@/pages/record-and-send/home/home-search';
import { RecordAndSendHome } from '@/pages/record-and-send/home/record-and-send-home';

const homeSearchSchema = z.object({
	tab: z.enum(HOME_TABS).optional().catch(undefined),
	q: z.string().optional().catch(undefined),
	videoTypeId: z.string().optional().catch(undefined),
	show: z.enum(INBOX_SHOWS).optional().catch(undefined),
	page: z.coerce.number().int().min(1).optional().catch(undefined),
	pageSize: z.coerce
		.number()
		.refine((size) => PAGE_SIZES.includes(size))
		.optional()
		.catch(undefined),
	types: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_app/record-and-send/')({
	validateSearch: homeSearchSchema,
	component: RecordAndSendHome,
});
